import React from "react";
import withRipple from 'jd-library/withRipple';
import styles from './SectionLabel.scss';

const SectionLabel = withRipple(props => {
    return (
        <div
            className={`${styles['list-box']} ${styles['section-alignment']} ${props.rippleClass}`}
            onClick={props.onClick}
            {...props.rippleHandler}
        >
                <div className={styles['section-label-container']}>
                    <div className={styles['section-label']}>{props.title}</div>
                    <div className={styles['section-label-subtext']}>{props.subTitle}</div>
                </div>
                <i className="icon-Next"></i>
                {props.renderRipple()}
        </div>
    );
});

export default SectionLabel;